"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionBidsResponseDtoListingStatusEnum = exports.AuctionBidsResponseDtoListingTypeEnum = void 0;
exports.instanceOfAuctionBidsResponseDto = instanceOfAuctionBidsResponseDto;
exports.AuctionBidsResponseDtoFromJSON = AuctionBidsResponseDtoFromJSON;
exports.AuctionBidsResponseDtoFromJSONTyped = AuctionBidsResponseDtoFromJSONTyped;
exports.AuctionBidsResponseDtoToJSON = AuctionBidsResponseDtoToJSON;
exports.AuctionBidsResponseDtoToJSONTyped = AuctionBidsResponseDtoToJSONTyped;
var AuctionBidDto_1 = require("./AuctionBidDto");
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var AuctionBidsPropertyDto_1 = require("./AuctionBidsPropertyDto");
/**
 * @export
 */
exports.AuctionBidsResponseDtoListingTypeEnum = {
    PrivateSale: 'private_sale',
    Auction: 'auction',
    ReverseAuction: 'reverse_auction'
};
/**
 * @export
 */
exports.AuctionBidsResponseDtoListingStatusEnum = {
    Draft: 'draft',
    Active: 'active',
    UnderOffer: 'under_offer',
    OffTheMarket: 'off_the_market',
    PassedIn: 'passed_in',
    Disabled: 'disabled',
    Deleted: 'deleted',
    Sold: 'sold'
};
/**
 * Check if a given object implements the AuctionBidsResponseDto interface.
 */
function instanceOfAuctionBidsResponseDto(value) {
    if (!('listingType' in value) || value['listingType'] === undefined)
        return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined)
        return false;
    if (!('bids' in value) || value['bids'] === undefined)
        return false;
    return true;
}
function AuctionBidsResponseDtoFromJSON(json) {
    return AuctionBidsResponseDtoFromJSONTyped(json, false);
}
function AuctionBidsResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listingType': json['listingType'],
        'listingStatus': json['listingStatus'],
        'property': json['property'] == null ? undefined : (0, AuctionBidsPropertyDto_1.AuctionBidsPropertyDtoFromJSON)(json['property']),
        'bids': (json['bids'].map(AuctionBidDto_1.AuctionBidDtoFromJSON)),
        'pagination': json['pagination'] == null ? undefined : (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function AuctionBidsResponseDtoToJSON(json) {
    return AuctionBidsResponseDtoToJSONTyped(json, false);
}
function AuctionBidsResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listingType': value['listingType'],
        'listingStatus': value['listingStatus'],
        'property': (0, AuctionBidsPropertyDto_1.AuctionBidsPropertyDtoToJSON)(value['property']),
        'bids': (value['bids'].map(AuctionBidDto_1.AuctionBidDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
